import * as React from 'react';

import { useSnackbar } from 'notistack';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

export const useGrdSupplyGrilles = (productType: string, application: string) => {
    const [ settings ] = Settings.useSettings();
    const { enqueueSnackbar } = useSnackbar();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Grd.SizingServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Grd.SizingServiceClient, settings.servicesUrl, 'bff.cygnus.grd.sizing'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Grd.SizingContext());
    React.useEffect(() => {(async () => {
        await serviceClient?.init(context, new Services.Grd.SizingInitializationParams({
            productType,
            application,
            defaults: [
                new Services.Common.QuestionDefault({
                    name: 'Model',
                    value: 'XG-H4002',
                    restrict: true
                })
            ],
            sizes: [
                new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize(),
                // new Services.Grd.SizingSize()
            ]
        }));
        setContext(context.clone());
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient ]);

    const addSize = () => (async () => {
        await serviceClient?.addSize(context);
        setContext(context.clone());
    })().catch(err => {
        enqueueSnackbar(err.toString(), { variant: 'error' });
    });

    return [ context, addSize ] as const;
}